export default "__VITE_ASSET__BtfsuRD1__"